<div class="single-blog-post-box">
  <div class="entry-thumbnail">
    <a [routerLink]="'/blog/' + blogItem.contentSlug"><img [src]="blogItem.featureImageUrl" alt="image" /></a>
  </div>
  <div class="entry-post-content">
    <div class="entry-meta">
      <ul>
        <li>
          {{ blogItem.authorName.trim() }}
        </li>
        <li>{{ blogItem.contentPublishDate | date: 'dd MMM yyyy' }}</li>
      </ul>
    </div>
    <h3>
      <a [routerLink]="'/blog/' + blogItem.contentSlug">{{ blogItem.contentTitle | shorten: 55:'...' }}</a>
    </h3>
    <p>{{ blogItem.contentDescription | shorten: 200:'...' }}</p>
    <a [routerLink]="'/blog/' + blogItem.contentSlug" class="learn-more-btn"
      ><span i18n="@@readBlogStory">Read Story</span><i-feather name="plus-circle"></i-feather
    ></a>
  </div>
</div>
